/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-11 11:03:15
 * @LastEditTime: 2019-08-11 11:23:06
 * @LastEditors: Please set LastEditors
 */
// manulTrack.js

/**
 *
 * @description 由于神策的全埋点中，webclick事件仅支持(a、input、button)三个元素，不能满足其他比如div、img、span、等元素的点击埋点。因此，在项目中如果某一个元素（除a、input、button以外）需要添加全埋点的webclick事件，则在该元素中添加 data-track 属性即可。
 *
 * 通过自定义指令， 当页面中 带有 'v-track' 的元素被插入到dom中的时候， 执行addManulTrack
 *
 */

import Vue from 'vue'
import sa from 'sa-sdk-javascript'
import storage from 'storejs';
import store from './../store'

// 添加事件监听
function addManulTrack (el) {
  let userInfo = {}
  try {
    userInfo = JSON.parse(storage(ACTIVITY.ACTIVITY_NAME))
  } catch (error) {

  }
  console.log(userInfo)
  if (document.addEventListener) {
    el.addEventListener('click', () => {
      /* sa.quick('trackHeatMap', el, {
        ActivityID: userInfo.activityId,
        Activitychannel: store.state.channel
      }) */
      console.log(el)
      console.log(el.getAttribute('id'))
      sa.track('_Activityelementclick', {
        $element_id: el.getAttribute('id'),
        activityId: userInfo.activityId,
        activityChannel: store.state.channel
      })
    })
  } else {
    el.attachEvent('onclick', () => {
      console.log(el)
      console.log(el.getAttribute('id'))
      sa.track('_Activityelementclick', {
        $element_id: el.getAttribute('id'),
        activityId: userInfo.activityId,
        activityChannel: store.state.channel
      })
    })
  }
}

// 添加事件监听
function addManulTrackVideo (el, obj) {
  // console.log(obj, 'qqqqqqq')
  let userInfo = {}
  try {
    userInfo = JSON.parse(storage(ACTIVITY.ACTIVITY_NAME))
  } catch (error) {

  }
  // console.log(userInfo)
  // console.log(el)
  // console.log(el.getAttribute('id'))
  let data = {
    $element_id: el.getAttribute('id'),
    activityId: userInfo.activityId,
    activityChannel: store.state.channel
  }
  // console.log(data)
  let buryData = Object.assign({}, data, obj)
  // console.log(buryData, 'buryData')
  if (document.addEventListener) {
    el.addEventListener('click', () => {
      /* sa.quick('trackHeatMap', el, {
        ActivityID: userInfo.activityId,
        Activitychannel: store.state.channel
      }) */
      console.log(buryData, 'buryData')
      sa.track('_ActivityVideoPlay', buryData)
    })
  } else {
    el.attachEvent('onclick', () => {
      sa.track('_ActivityVideoPlay', buryData)
    })
  }
}

Vue.directive('track', {
  inserted: (el) => {
    addManulTrack(el)
  }
})
Vue.directive('trackVideo', {
  inserted: (el, binding) => {
    // console.log(binding, 'binding')
    addManulTrackVideo(el, binding.value)
  }
})



// WEBPACK FOOTER //
// ./src/utils/manulTrack.js